import { render, staticRenderFns } from "./menu-bar.vue?vue&type=template&id=0058f856&scoped=true"
import script from "./menu-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./menu-bar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./menu-bar.vue?vue&type=style&index=0&id=0058f856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0058f856",
  null
  
)

export default component.exports